export const style = {
  description: "description",
  textArea: "text_area",
  fileS: "file"
};
